import React from 'react';
import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";

const OccurrenceReason = ({data}) => {
    const reason = data.reason ?? []
    if (!reason.length || !reason) return null;

    return (
        <>
            { reason && (
                <section className="space-y-4! px-5!">
                    <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f] print:text-[19px]! print:break-after-avoid! mb-2">
                        NATUREZAS
                    </h2>

                    { reason.map((item, index) => {

                        const info = [
                            {
                                label: "Natureza",
                                value: `${item?.name} ${item?.flags ? item?.flags : ""}`,
                                span: 3
                            }
                        ];

                        return (
                            <>
                                <InfoGrid key={`${index}`} title={""} items={info} columns={3} labelClassName="text-[#4F4F4F] text-[13px]! print:text-[15px]!" valueClassName={'print:text-[17px]!'} className={'px-0!'} contentClassName={'space-y-1'}/>
                            </>
                        )

                    })}
                </section>
            )}
        </>
    );
};

export default OccurrenceReason;